import React from 'react'

export default class SelectModalResult extends React.Component {
  constructor(props) {
    super(props)
    this.state = {}
  }

  static defaultProps = {
    prefixCls: 'mkui-modal-result'
  }

  componentDidMount(){
  }

  render(){
    const {prefixCls, children, title, onClearAll} = this.props
    return (
      <div className={prefixCls}>
        <div className="mkui-modal-result-title">
          {title}
          {onClearAll?<div className="clear-all" onClick={() => {onClearAll()}}>全部清除</div> :null}
        </div>
        <div className="mkui-modal-result-content">{children}</div>
      </div>
    );
  }
}
